import { useUser } from '@lore/auth';
import _ from 'lodash';
import usePageRouter from '@hooks/@lore/dialogs-routable/_hooks/usePageRouter';
import useNetwork from '@/hooks/useNetwork';
import { getSchoolYearRoot } from '@/utils/schoolYearPath';
import getSchoolYearNavigationLinks from './schoolYearNavigationLinks';
import getPageNavigationLinks from './pageNavigationLinks';

export default function useNavigationLinks() {
  const { location } = usePageRouter();

  const network = useNetwork();
  const currentUser = useUser();

  const schoolYearNavigationLinks = getSchoolYearNavigationLinks(network, currentUser);

  const currentSchoolYearNavigationLink = _.find(schoolYearNavigationLinks, function(schoolYear) {
    // return _.startsWith(location.pathname, schoolYear.href);
    const tokens = location.pathname.split(schoolYear.href);
    const remainder = tokens[1];
    return remainder ? remainder[0] === '/' : false;
  });

  // the year in the url may not be in the list (e.g. it predates the network), so fall back to it for page links
  const yearRoot = getSchoolYearRoot(location.pathname);
  const pageRootLink = currentSchoolYearNavigationLink || (yearRoot ? { href: yearRoot } : undefined);

  const pageNavigationLinks = pageRootLink ?
    getPageNavigationLinks(network, currentUser, pageRootLink) :
    [];

  return {
    pageLinks: pageNavigationLinks,
    schoolYearLinks: schoolYearNavigationLinks,
    currentSchoolYearLink: currentSchoolYearNavigationLink
  };
}
